import React from "react"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from "styled-components"
import { rem } from "polished"

const Container = styled.section`
  padding: ${rem(200)} 0;
  background-color: ${props => props.theme.colorSand};

  @media ${props => props.theme.largeDown} {
    padding: ${rem(120)} 0;
  }

  @media ${props => props.theme.smallDown} {
    padding: ${rem(60)} 0;
  }
`

const Inner = styled.div`
  ${props => props.theme.gridContainer()}
  ${props => props.theme.gridGrid()}
  ${props => props.theme.gridGridGutterX()}

  align-items: center;
  justify-content: space-around;

  @media ${props => props.theme.smallDown} {
    ${props => props.theme.gridGridGutterY(20)}
  }
`

const Image = styled.figure`
  ${props => props.theme.gridCell(5)}

  order: 1;

  @media ${props => props.theme.smallDown} {
    ${props => props.theme.gridCell(9)}

    order: 0;
  }
`

const Info = styled.figure`
  ${props => props.theme.gridCell(6)}

  text-align: center;

  @media ${props => props.theme.smallDown} {
    ${props => props.theme.gridCell(10)}
  }

  > h2 {
    margin-bottom: ${rem(30)};
  }
`

const FeatureFinance = ({ data }) => (
  <Container>
    <Inner>
      <Image>
        <Img fluid={data.image.childImageSharp.fluid} />
      </Image>

      <Info>
        <h2 className="styled-h3">
          Financial
          <br />
          Incentives
        </h2>

        <p className="styled-p-leading">
          Integrates with and enables out-of-app incentives such as refunds,
          reimbursement & rewards provided by plan sponsors
        </p>
      </Info>
    </Inner>
  </Container>
)

FeatureFinance.propTypes = {
  data: PropTypes.object,
}

export default props => (
  <StaticQuery
    query={graphql`
      query {
        image: file(
          sourceInstanceName: { eq: "images" }
          relativePath: { eq: "photos/feature-finance.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 1336) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `}
    render={data => <FeatureFinance data={data} {...props} />}
  />
)
